import { createSlice } from "@reduxjs/toolkit"
import { DateFilterValue } from "features/pilot-tracking/filters/DateFilter"
import { PilotFilterValue } from "features/pilot-tracking/filters/PilotFilter"

export type ChecklistDetailsTab = "Questions" | "Responses"
type ChecklistDetailsState = {
    tab: ChecklistDetailsTab
    dateFilter: DateFilterValue | null
    pilotFilter: PilotFilterValue | null
}

const initialState: ChecklistDetailsState = {
    tab: "Questions",
    dateFilter: null,
    pilotFilter: null,
}

export const checklistDetailsSliceName = "checklist-details" as const

export const {
    reducer: ChecklistDetailsReducer,
    actions: { setTab, setDateFilter, setPilotFilter },
} = createSlice({
    name: checklistDetailsSliceName,
    initialState,
    reducers: {
        setTab: (state, action: { payload: ChecklistDetailsState["tab"] }) => {
            state.tab = action.payload
        },
        setDateFilter: (state, action: { payload: DateFilterValue | null }) => {
            state.dateFilter = action.payload
        },
        setPilotFilter: (state, action: { payload: PilotFilterValue | null }) => {
            state.pilotFilter = action.payload
        },
    },
})
